module.exports = __webpack_public_path__ + "assets/question-cloud_icon.d7d8dfd1.svg";